import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getStoredConsent } from '../../lib/gtag';

export default function Footer() {
  const [showCookieButton, setShowCookieButton] = useState(false);

  useEffect(() => {
    const updateCookieButton = () => {
      try {
        const hasDecision = getStoredConsent() !== 'unset';
        setShowCookieButton(hasDecision);
      } catch {
        setShowCookieButton(false);
      }
    };

    updateCookieButton();
    window.addEventListener('storage', updateCookieButton);
    window.addEventListener('consent-updated', updateCookieButton as EventListener);

    return () => {
      window.removeEventListener('storage', updateCookieButton);
      window.removeEventListener('consent-updated', updateCookieButton as EventListener);
    };
  }, []);

  return (
    <footer className="py-14 bg-[#0B1F3A] border-t border-[#1E3A5F] text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
          {/* Logo & Beschreibung */}
          <div className="md:col-span-2 flex flex-col items-center md:items-start">
            <a
              href="/#hero"
              className="mb-4 flex items-center gap-3 justify-center md:justify-start"
            >
              <div className="text-lg md:text-xl tracking-wide leading-none">
                <span className="font-bold text-[#38BDF8]">ABSCHLEPP</span>
                <span className="font-semibold text-white">DIREKT24</span>
              </div>
            </a>
            <p className="text-[#BFDBFE] mb-6 max-w-md text-sm md:text-base leading-relaxed">
              AbschleppDirekt24 – Ihr privater Pannen- und Abschleppdienst für Berlin und Umgebung. 24/7 Pannenhilfe, Fahrzeugbergung, Abschleppen von Falschparkern sowie Fahrzeugtransporte zu fairen und transparenten Preisen.
            </p>
            <div className="flex space-x-4 justify-center md:justify-start">
              <a
                href="tel:+4915214468574"
                className="w-11 h-11 rounded-full flex items-center justify-center bg-[#123E7A] border border-[#38BDF8]/30 shadow-[0_10px_24px_rgba(11,31,58,0.35)] hover:bg-[#1D4ED8] hover:border-[#7DD3FC] transition-colors"
              >
                <i className="ri-phone-line text-white text-lg" />
              </a>
              <a
                href="mailto:info@abschleppdirekt24.de"
                className="w-11 h-11 rounded-full flex items-center justify-center bg-[#123E7A] border border-[#38BDF8]/30 shadow-[0_10px_24px_rgba(11,31,58,0.35)] hover:bg-[#1D4ED8] hover:border-[#7DD3FC] transition-colors"
              >
                <i className="ri-mail-line text-white text-lg" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-semibold text-xl md:text-2xl mb-4 text-[#E0F2FE]">
              Schnellzugriff
            </h4>
            <ul className="space-y-2 text-sm md:text-base">
              <li>
                <a href="/#hero" className="text-[#BFDBFE] hover:text-[#38BDF8] transition-colors">
                  Startseite
                </a>
              </li>
              <li>
                <a href="/#services" className="text-[#BFDBFE] hover:text-[#38BDF8] transition-colors">
                  Unsere Services
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-[#BFDBFE] hover:text-[#38BDF8] transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/#kontakt" className="text-[#BFDBFE] hover:text-[#38BDF8] transition-colors">
                  Kontakt & Notruf
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E3A5F] mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#93C5FD] text-xs md:text-sm text-center md:text-left">
            © 2025 AbschleppDirekt24. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-6 mt-2 md:mt-0 justify-center md:justify-end text-xs md:text-sm">
            <Link
              to="/impressum"
              className="text-[#93C5FD] hover:text-[#38BDF8] transition-colors"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-[#93C5FD] hover:text-[#38BDF8] transition-colors"
            >
              Datenschutz
            </Link>
            {showCookieButton && (
              <button
                type="button"
                onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-settings'))}
                className="text-[#93C5FD] hover:text-[#38BDF8] transition-colors"
              >
                Cookie-Einstellungen
              </button>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
